<template>
  <template v-if="hasChildren">
    <q-expansion-item
        :content-inset-level="level + 0.2"
        :active="isActive"
        :header-inset-level="level"
        class="q-ml-none"
    >
      <template v-slot:header>
        <q-item-section
            @click.prevent="$emit('select', item)"
            :class="isActive ? 'text-primary' : ''"
        >
          {{ item.name }}
        </q-item-section>
      </template>

      <q-list dense>
        <ProjectTypeSelect
            v-for="child in item.children"
            :key="child.id"
            :item="child"
            :level="level + 0.2"
            :selected-id="selectedId"
            @select="$emit('select', $event)"
        />
      </q-list>
    </q-expansion-item>
  </template>

  <template v-else>
    <q-item
        clickable
        v-ripple
        @click="$emit('select', item)"
        :active="isActive"
        active-class="text-blue-8 bg-blue-3"
    >
      <q-item-section>{{ item.name }}</q-item-section>
    </q-item>
  </template>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {ProjectTypeSummary as PT} from "../models/project";

const props = defineProps<{
  item: PT,
  level: number,
  selectedId: number | null | undefined,
}>();

const hasChildren = computed(() =>
    props.item.children && props.item.children.length > 0
);

const isActive = computed(() =>
    props.item.id === props.selectedId
);
</script>